import React, { useState, useContext, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { getEndUserDetails } from '../../api';
import { BankpayLogo, MenuLogo } from '../../assets/index';
import { bankpay_consumer_user_id, userlogo } from '../../common/constants';
import {
    getLocalStorageData,
    getUserToken,
} from '../../common/resubale-functions';
import Navigation from '../bottom_navigator';
import { MainContext } from '../context/context';
import Menu from '../Menu';
import { User } from 'react-feather';
import { Link } from "react-router-dom";


const Layout = (props) => {
    const history = useHistory();
    const context = useContext(MainContext);
    const {
        loginTokenContext,
        setLOginTokenContext,
        setUserIdContext,
        setUserLogoContext,
        path,
        setPath,
    } = context;
    const { children } = props;
    const user = getUserToken();
    const search = useLocation().search;
    const user_id = getLocalStorageData(bankpay_consumer_user_id, 'string');
    const background = getLocalStorageData(userlogo, 'string');
    const merchantId = new URLSearchParams(search).has('merchant');
    const orderId = new URLSearchParams(search).has('order_id');
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        if (user) setLOginTokenContext(user);
        if (user_id) setUserIdContext(user_id);
        if (background) setUserLogoContext(background);
    }, [user, user_id, background]);

    useEffect(() => {
        setPath(window.location.pathname);
    }, [window.location.pathname]);

    const handleShowMenu = () => {
        history.push('/account');
    };
    return (
        <>
            {loginTokenContext ? <div className='page-wrap h-full'>
                <div className='page-inner flex flex-col h-full'>
                    {
                        <div
                            className="page-header shrink-0 p-4 lg:px-20 border-b border-b-[#E9ECEF] flex gap-4 justify-between items-center flex-col lg:flex-row">
                            <div className="page-bottom-left grow text-white text-base">
                                <Link to=''>
                                    <a href="">
                                        <svg className="h-4 w-16 text-[#0F0F0F]" width="56" height="14" viewBox="0 0 56 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.79895 3.56V5.96H15.2112V9.52H6.79895V14H0V0H16.3924V3.56H6.79895Z" fill="#0F0F0F" />
                                            <path d="M26.9413 11.56H19.278L17.924 14H11.0098L19.8254 0H26.5091L35.3247 14H28.2953L26.9413 11.56ZM25.0687 8.16L23.1096 4.64L21.1506 8.16H25.0687Z" fill="#0F0F0F" />
                                            <path d="M49.806 14L49.7484 7.62L45.3694 12.74H42.3733L37.9943 7.84V14H31.8003V0H37.3893L43.9578 7.46L50.3534 0H55.9424L56 14H49.806Z" fill="#0F0F0F" />
                                        </svg>
                                    </a>
                                </Link>
                            </div>
                            <div className="page-bottom-right hidden lg:block">
                                <ul className="page-bottim-link flex gap-2 lg:gap-10 flex-col lg:flex-row text-center lg:text-end">
                                    <li>
                                        <Link to='/credits'>
                                            <a href="" className={`text-base font-bold font-Rany hover:text-[#0F0F0F] ${path == '/credits' ? 'text-[#0F0F0F]' : 'text-[#6C757D]'}`}>Credits</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/orders'>
                                            <a href="" className={`text-base font-bold font-Rany hover:text-[#0F0F0F] ${path == '/orders' ? 'text-[#0F0F0F]' : 'text-[#6C757D]'}`}>Orders</a>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/account'>
                                            <a href="" className={`text-base font-bold font-Rany hover:text-[#0F0F0F] ${path == '/account' ? 'text-[#0F0F0F]' : 'text-[#6C757D]'}`}>Account</a>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    }
                    <div className="page-container grow overflow-auto p-4 h-full">
                        {children}
                    </div>

                    {loginTokenContext && !(orderId || merchantId) ? <Navigation path={path} setPath={setPath} /> : ''}
                </div>
            </div> : <div>{children}</div>
            }
        </>
    );
};

export default Layout;
